import React, { useState, useEffect } from 'react';
import { Typography } from '@material-ui/core';
import { orange } from '@material-ui/core/colors';

export const InactivityCounter = () => {
  const initialSeconds = 3 * 60;
  const [seconds, setSeconds] = useState(initialSeconds);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setSeconds(prevSeconds => prevSeconds + 1);
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  return (
    <div style={{
      padding: 8,
      position: 'absolute',
      top: 16,
      left: '50%',
      transform: 'translateX(-50%)',
      backgroundColor: orange[500],
      zIndex: 2,
      borderRadius: 4,
    }}>
      <Typography variant="subtitle1">{`Tiempo inactivo ${minutes} minutos : ${remainingSeconds < 10 ? '0' : ''}${remainingSeconds} segundos`}</Typography>
    </div>
  );
};
